module.exports = __webpack_public_path__ + "static/media/doc1.f917933e.png";